document.addEventListener("DOMContentLoaded", function () {
    const whatToExpectSection = document.querySelector(".what_to_expect");
    if (!whatToExpectSection) return;
    const STEP_DURATION = 10000; 
    const HEX_DELAY = 300; 
    const hexString = "{{ section.settings.hex_data | strip }}";
    const hexArray = hexString.split(",").map(v => parseInt(v.trim()) || 0);
    const classMap = ["first-hex", "second-hex", "third-hex", "fourth-hex"];
    if (window.innerWidth >= 999) {
        const gridItem = whatToExpectSection.querySelector(".grid_item");
        const progressFill = whatToExpectSection.querySelector(".progress-fill");
        const hexWrapper = whatToExpectSection.querySelector(".hex-wrapper");
        if (!gridItem || !progressFill || !hexWrapper) return;
        const contentBlocks = gridItem.querySelectorAll(".content_block .content");
        const images = gridItem.querySelectorAll(".image_block .image");
        const totalSteps = contentBlocks.length;

        hexWrapper.innerHTML = "";
        const columnPositions = [11.5, 37, 63, 88.5]; // Or use: [12.5, 37.5, 62.5, 87.5] if you want center of each column
        columnPositions.forEach((position, index) => {
            const hex = document.createElement("div");
            hex.classList.add("hex");
            hex.style.left = position + "%";
            hexWrapper.appendChild(hex);
        });
        let isHovering = false;
        let isClickPaused = false;
        let currentStep = 0; 
        let animationTimeout = null;
        let isAutoPlaying = false;
        function setActivePair(index) {
            images.forEach(el => el.classList.remove("active"));
            contentBlocks.forEach(el => el.classList.remove("active"));
            if (images[index]) images[index].classList.add("active");
            if (contentBlocks[index]) contentBlocks[index].classList.add("active");
        }
        function clearActivePair() {
            images.forEach(el => el.classList.remove("active"));
            contentBlocks.forEach(el => el.classList.remove("active"));
        }
        function updateStepVisuals(index) {
            hexWrapper.className = "hex-wrapper"; 
            if (classMap[index] !== undefined) {
                hexWrapper.classList.add(classMap[index]);
            }
            setActivePair(index);
        }
function getTargetWidth(stepIndex) {
    if (stepIndex === -1) return "0%";
    if (stepIndex === totalSteps) return "100%"; // ✅ allow full fill
    return columnPositions[stepIndex] + "%";
}
       function setProgressBarToStep(stepIndex, immediate = false) {
    const targetWidth = getTargetWidth(stepIndex);
    const currentPercent = parseFloat(progressFill.style.width) || 0;
    const targetPercent = parseFloat(targetWidth);
    if (immediate || targetPercent < currentPercent) {
        progressFill.style.transition = 'none';
        progressFill.style.width = targetWidth;
        void progressFill.offsetWidth; 
        return 0;
    } else {
        const distance = Math.abs(targetPercent - currentPercent);
        const duration = (distance / 100) * STEP_DURATION;
        progressFill.style.transition = `width ${duration}ms linear`;
        progressFill.style.width = targetWidth;
        return duration;
    }
}
        function stopAutoPlay() {
            if (animationTimeout !== null) {
                clearTimeout(animationTimeout);
                animationTimeout = null;
            }
            isAutoPlaying = false;
        }
        function startAutoPlay() {
            if (isAutoPlaying || isClickPaused || isHovering) return;
            isAutoPlaying = true;
            function playNextStep() {
                if (!isAutoPlaying || isClickPaused || isHovering) return;
                if (currentStep === totalSteps) {
    const fillTime = setProgressBarToStep(totalSteps);
    animationTimeout = setTimeout(() => {
        setProgressBarToStep(-1, true);
        hexWrapper.className = "hex-wrapper";
        clearActivePair();
        currentStep = 0;
        animationTimeout = setTimeout(playNextStep, 500);
    }, fillTime + 600);
    return;
}
                const stepIndex = currentStep;
                const isLastStep = stepIndex === totalSteps - 1;
                if (isLastStep) {
                    const timeToHex = setProgressBarToStep(stepIndex, false, true);
                    animationTimeout = setTimeout(() => {
                        if (!isAutoPlaying || isClickPaused || isHovering) return;
                        updateStepVisuals(stepIndex);
                        const timeTo100 = setProgressBarToStep(stepIndex);
                        animationTimeout = setTimeout(() => {
                            if (!isAutoPlaying || isClickPaused || isHovering) return;
                            currentStep++;
                            playNextStep();
                        }, timeTo100 + HEX_DELAY);
                    }, timeToHex);
                } else {
                    const animationTime = setProgressBarToStep(stepIndex);
                    animationTimeout = setTimeout(() => {
                        if (!isAutoPlaying || isClickPaused || isHovering) return;
                        updateStepVisuals(stepIndex);
                        animationTimeout = setTimeout(() => {
                            if (!isAutoPlaying || isClickPaused || isHovering) return;
                            currentStep++;
                            playNextStep();
                        }, HEX_DELAY);
                    }, animationTime);
                }
            }
            playNextStep();
        }
        function handleHover(index) {
            isHovering = true;
            stopAutoPlay();
            currentStep = index;
            updateStepVisuals(index);
            if (index === totalSteps - 1) {
                setProgressBarToStep(index, true, true);
            } else {
                setProgressBarToStep(index, true);
            }
        }
        function handleHoverEnd() {
            isHovering = false;
            if (!isClickPaused) {
                if (currentStep >= totalSteps - 1) {
                    progressFill.style.transition = 'width 500ms ease-in-out';
                    progressFill.style.width = "100%";
                    setTimeout(() => {
                        if (isHovering) return;
                        currentStep = 0;
                        setProgressBarToStep(-1, true);
                        hexWrapper.className = "hex-wrapper";
                        clearActivePair();
                        startAutoPlay();
                    }, 600);
                } else {
                    setTimeout(startAutoPlay, 50);
                }
            }
        }
        function handleClick(index) {
            stopAutoPlay();
            isClickPaused = true;
            currentStep = index;
            updateStepVisuals(index);
            setProgressBarToStep(index, true);
            setTimeout(() => {
                isClickPaused = false;
                if (!isHovering) setTimeout(startAutoPlay, 0);
            }, 2000);
        }
        contentBlocks.forEach((content, index) => {
            content.addEventListener("click", () => handleClick(index));
            content.addEventListener("mouseenter", () => handleHover(index));
            content.addEventListener("mouseleave", handleHoverEnd);
        });
        images.forEach((img, index) => {
            img.addEventListener("click", () => handleClick(index));
            img.addEventListener("mouseenter", () => handleHover(index));
            img.addEventListener("mouseleave", handleHoverEnd);
        });
        const contentObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const stepIndex = parseInt(entry.target.dataset.step);
                if (entry.isIntersecting && !isClickPaused && !isHovering) {
                    stopAutoPlay();
                    currentStep = stepIndex;
                    updateStepVisuals(currentStep);
                    setProgressBarToStep(currentStep, true);
                    setTimeout(startAutoPlay, 100);
                }
            });
        }, {
            root: null,
            threshold: 0.6 // Trigger when 60% of the block is visible
        });
        contentBlocks.forEach(content => contentObserver.observe(content));
        const sectionObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!isClickPaused && !isHovering) setTimeout(startAutoPlay, 0);
                } else {
                    stopAutoPlay();
                    currentStep = 0;
                    setProgressBarToStep(-1, true);
                    clearActivePair();
                    hexWrapper.className = "hex-wrapper";
                }
            });
        }, { threshold: 0.1 });
        sectionObserver.observe(whatToExpectSection);
    }
    if (window.innerWidth < 999) {
        const mobileBlocks = whatToExpectSection.querySelectorAll(".for-mobile .image_content_block");
        mobileBlocks.forEach(block => {
            block.addEventListener("click", function(event) {
                mobileBlocks.forEach(b => b.classList.remove("active"));
                this.classList.add("active");
                event.stopPropagation();
            });
        });
        if (mobileBlocks.length > 0 && !whatToExpectSection.querySelector('.image_content_block.active')) {
            mobileBlocks[0].classList.add("active");
        }
    }
  window.addEventListener('resize', function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => location.reload(), 250);
});
});